module.exports = __webpack_public_path__ + "static/media/15.57bccda4.mp3";